document.addEventListener('DOMContentLoaded', function() {
  const switcher = document.querySelector('.currency-switcher');
  const button = document.querySelector('.currency-button');
  const dropdown = document.querySelector('.currency-dropdown');
  const options = document.querySelectorAll('.currency-option');

  if (!switcher || !button || !dropdown) return;

  // Toggle dropdown
  button.addEventListener('click', function(e) {
    e.preventDefault();
    switcher.classList.toggle('open');
  });

  // Handle option selection
  options.forEach(function(option) {
    option.addEventListener('click', function() {
      const currency = this.getAttribute('data-currency');
      const locale = this.getAttribute('data-locale');
      const flagImg = this.querySelector('img');
      const optionText = this.textContent.trim();

      // Update button display - just the flag
      button.innerHTML = '<img src="' + flagImg.src + '" class="currency-flag" alt="' + currency + '">';

      // Close dropdown
      switcher.classList.remove('open');

      // Store preference
      document.cookie = 'currency=' + currency + '; path=/; max-age=31536000';

      // Switch to the selected market/locale
      switchMarket(currency, locale);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!switcher.contains(e.target)) {
      switcher.classList.remove('open');
    }
  });

  function switchMarket(currency, locale) {
    // Map currency to country code for market switching
    const currencyToCountry = {
      'USD': 'US',
      'CAD': 'CA',
      'AUD': 'AU',
      'NZD': 'NZ',
      'GBP': 'GB'
    };
    const countryCode = currencyToCountry[currency] || 'US';

    // Check if we're in dev mode or theme preview mode
    const isLocalDev = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    const isPreviewMode = window.location.search.includes('preview_theme_id');

    if (isLocalDev || isPreviewMode) {
      // Use URL parameter fallback for dev/preview mode
      const url = new URL(window.location);
      url.searchParams.set('country', countryCode);
      window.location.href = url.toString();
      return;
    }

    // Get current path without any existing locale prefix
    let currentPath = window.location.pathname;
    const localePattern = /^\/(en-us|en-ca|en-au|en-nz|en-gb)(\/|$)/i;
    currentPath = currentPath.replace(localePattern, '/');

    // Build new URL - US doesn't need locale prefix
    let newPath;
    if (locale === 'en-us') {
      newPath = currentPath;
    } else {
      newPath = '/' + locale + currentPath;
    }

    // Redirect to the appropriate URL
    window.location.href = newPath + window.location.search;
  }
}); 